import CancelIcon from '@mui/icons-material/Cancel';
import CheckIcon from '@mui/icons-material/CheckCircle';
import CircleIcon from '@mui/icons-material/Circle';
import { Step, Stepper } from '@mui/material';
import { useLocalization } from '@utils/useLocalization';
import { Box, Typography, useTheme } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';

type IStep = {
  name: string;
};

export const StateStepper = ({
  steps,
  failed,
  activeStep,
  currentState,
  stateChanges,
}: {
  steps: IStep[];
  failed: boolean;
  activeStep: number;
  currentState: string;
  stateChanges: any;
}) => {
  const theme = useTheme();
  const { localizedDateTime } = useLocalization();
  const { t } = useTranslation('transfer');
  const StepIcon = ({ index }: { index: number }) => {
    if (failed && index === activeStep) {
      return <CancelIcon sx={{ color: theme.color.negative }} />;
    }
    if (activeStep >= index) {
      return (
        <CheckIcon
          sx={{
            color:
              index + 1 === steps.length
                ? theme.color.positive
                : theme.color.primary,
          }}
        />
      );
    }
    return <CircleIcon sx={{ color: theme.color.background }} />;
  };

  return (
    <Stepper activeStep={activeStep} alternativeLabel>
      {steps.map((state, index) => {
        const effectiveState =
          failed && activeStep === index ? currentState : state.name;
        return (
          <Step key={index}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <StepIcon index={index} />
              <Typography
                variant='bodyMedium'
                sx={{ fontWeight: 600, mt: 1.5, mb: 0.5 }}
              >
                {t(`states.${effectiveState}`)}
              </Typography>
              {stateChanges.filter(
                (change: any) => change.to === effectiveState,
              ).length > 0 && (
                <Typography
                  variant='bodySmall'
                  color='textSecondary'
                  sx={{ textAlign: 'center' }}
                >
                  {localizedDateTime(
                    stateChanges
                      .filter((change: any) => change.to === effectiveState)
                      .slice(-1)[0].createdAt,
                  )}
                </Typography>
              )}
            </Box>
          </Step>
        );
      })}
    </Stepper>
  );
};
